// Per-step-type rules that mirror the Ruby side's `config_summary` and
// `config_complete?`. They run on the client so freshly-added or edited
// nodes show a meaningful summary + completeness state without a server
// round-trip (we batch saves to the /graph endpoint).

const RULES = {
  "input.segment": {
    keys: ["segment_id"],
    summary: (config, options) =>
      options?.segments?.find(s => s.id === config.segment_id)?.name ?? null
  },
  "enrichment.lead": {
    keys: ["prompt_id"],
    summary: (config, options) =>
      options?.prompts?.find(p => p.id === config.prompt_id)?.name ?? null
  },
  "enrichment.company": {
    keys: ["prompt_id"],
    summary: (config, options) =>
      options?.prompts?.find(p => p.id === config.prompt_id)?.name ?? null
  },
  "outreach.email_campaign": {
    keys: ["campaign_id"],
    summary: (config, options) =>
      options?.campaigns?.find(c => c.id === config.campaign_id)?.name ?? null
  }
}

export function configComplete(stepType, config) {
  const rule = RULES[stepType]
  if (!rule) return true
  return rule.keys.every(k => {
    const v = config?.[k]
    return v !== null && v !== undefined && v !== ""
  })
}

export function configSummary(stepType, config, options) {
  return RULES[stepType]?.summary?.(config ?? {}, options) ?? null
}

// Mirrors GTM::Steps::Base.config_extras (and per-class overrides).
// Returns [{ label, value, tone? }] entries shown as a secondary detail
// block on the canvas card. Keep in sync with app/domain/gtm/steps/**.
// `tone` is optional; "warning" renders amber to flag attention-needed
// configuration.
export function configExtras(stepType, config, options) {
  const c = config ?? {}
  const extras = []
  const limit = Number(c.limit) || 0
  if (limit > 0) extras.push({ label: "Limit", value: String(limit) })

  if (stepType?.startsWith("enrichment.") && c.model_id) {
    const model = options?.models?.find(m => m.id === c.model_id)
    if (model) extras.push({ label: "Model", value: model.name })
  }

  if (stepType === "outreach.email_campaign" && c.campaign_id) {
    const campaign = options?.campaigns?.find(cm => cm.id === c.campaign_id)
    if (campaign && campaign.status && campaign.status !== "active") {
      const humanized = campaign.status.charAt(0).toUpperCase() + campaign.status.slice(1)
      extras.push({ label: "Campaign", value: humanized, tone: "warning" })
    }
  }

  return extras
}
